import { baseColors, basePadding, dimensions } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        paddingVertical: basePadding.paddingVertical,
        paddingHorizontal: basePadding.paddingHorizontal
    },
    content: {
        alignItems: "center"
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: RFValue(4)
    },
    video: {
        marginVertical: 10,
        alignSelf: "center",
        // width: dimensions.fullWidth - 20,
        width: "100%",
        height: "100%",
        objectFit: "cover"
        // height: dimensions.fullHeight / 3
    },
    title: {
        marginVertical: RFValue(20)
    },
    author: {
        marginBottom: RFValue(20)
    },
    summaryTitle: {
        marginBottom: RFValue(20)
    }
})

export default styles
